import { Loader2, Tag, X } from 'lucide-react';

type AppliedCouponPillProps = {
  code: string;
  amountLabel: string;
  onRemove?: () => void;
  removing?: boolean;
};

export function AppliedCouponPill({
  code,
  amountLabel,
  onRemove,
  removing,
}: AppliedCouponPillProps) {
  if (!code) return null;
  return (
    <div className="flex min-w-0 items-center justify-between gap-3 rounded-full bg-[#E8F8EF] px-3.5 py-2">
      <span className="flex min-w-0 items-center gap-1.5 overflow-hidden text-[12px] font-bold tracking-wide text-[#1B7A4E] uppercase">
        <Tag className="h-3.5 w-3.5 shrink-0" strokeWidth={2.25} />
        <span className="truncate" title={code}>{code}</span>
      </span>
      <span className="flex shrink-0 items-center gap-2">
        <span className="shrink-0 text-[12px] font-bold text-[#1B7A4E] uppercase">
          {amountLabel}
        </span>
        {onRemove ? (
          <button
            type="button"
            onClick={onRemove}
            disabled={removing}
            aria-label={`Remove ${code}`}
            className="flex h-5 w-5 items-center justify-center rounded-full text-[#1B7A4E] transition hover:bg-[#CFF0DC] disabled:opacity-50"
          >
            {removing ? (
              <Loader2 className="h-3 w-3 animate-spin" />
            ) : (
              <X className="h-3 w-3" strokeWidth={2.5} />
            )}
          </button>
        ) : null}
      </span>
    </div>
  );
}
